"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusService = void 0;
const lodash_1 = require("lodash");
const Types_1 = require("./Types");
const Registry_1 = require("./Registry");
const LocalAdapter_1 = require("./LocalAdapter");
const ParserService_1 = require("./ParserService");
class BusService {
    constructor(options) {
        this.options = options;
        this.adapters = [];
        this.clientAdapters = [];
        this.createAdapters();
        this.createClientAdapters();
        this.setClientAdapter();
    }
    createAdapters() {
        this.options.adapters.forEach((adapter) => {
            const RegistryAdapter = Registry_1.registry.adapters[String(adapter.name)];
            if (RegistryAdapter) {
                const instance = new RegistryAdapter(this.options, adapter.options);
                this.adapters.push(instance);
            }
            else {
                console.warn(`[BusService]: Unknown ${String(adapter.name)} adapter.`);
            }
        });
    }
    createClientAdapters() {
        lodash_1.each(Registry_1.registry.clientAdapters, (adapter, adapterKey) => {
            const RegistryClientAdapter = Registry_1.registry.clientAdapters[adapterKey];
            const instance = new RegistryClientAdapter(this.options);
            this.clientAdapters.push(instance);
        });
    }
    setClientAdapter() {
        const messageProtocol = this.options.clientMessageProtocol;
        const messageProtocolName = messageProtocol ? messageProtocol.name : 'postMessage';
        this.clientAdapter = this.clientAdapters.find((clientAdapter) => clientAdapter.messageProtocol === messageProtocolName);
        if (this.clientAdapter && messageProtocol) {
            this.clientAdapter.setHandler(messageProtocol.handler);
        }
    }
    addChannel(channelType, channelName, onAdapters) {
        this.adapters.forEach((adapter) => {
            if (lodash_1.isNil(onAdapters) || onAdapters.indexOf(adapter.name) > -1) {
                adapter.addChannel(channelType, channelName);
            }
        });
    }
    getAdapter(name) {
        if (this.adapters) {
            return lodash_1.find(this.adapters, { name });
        }
    }
    async getState(adapterName) {
        if (this.adapters) {
            const adapter = this.getAdapter(adapterName);
            if (adapter) {
                const state = await adapter.getState(adapter.name);
                state.eventName = ParserService_1.eventNames.SetState;
                return state;
            }
        }
    }
    removeChannel(channelType, channelName) {
        this.adapters.forEach((adapter) => {
            adapter.removeChannel(channelType, channelName);
        });
    }
    proxyEvent(sourceEvent, targetEventName) {
        const event = new CustomEvent(targetEventName, {
            detail: sourceEvent.detail,
        });
        window.dispatchEvent(event);
    }
    sendMessage(message, isClientMessage, targetOrigin = '*') {
        if (isClientMessage) {
            if (this.clientAdapter) {
                this.clientAdapter.sendMessage(message, targetOrigin);
            }
            else {
                console.warn(`[BusService] ${Types_1.BusErrors.MissingClientAdapterError}`);
            }
        }
        else {
            this.adapters.forEach((adapter) => {
                adapter.sendMessage(message);
            });
        }
    }
    async sendManifest(manifest) {
        const localAdapter = lodash_1.find(this.adapters, { name: Types_1.Adapters.LocalAdapter });
        if (localAdapter instanceof LocalAdapter_1.LocalAdapter) {
            return localAdapter.sendManifest(manifest);
        }
    }
    sendMessageAsync() {
        if (this.clientAdapter && this.clientAdapter.handler) {
            return this.clientAdapter.handler.emitAsync;
        }
        return undefined;
    }
    sendGoogleTagManagerMessage(message, isClientMessage, targetOrigin = '*') {
        /*
        If we have client adapter then we will send
        Google Analytics message to parent for handing.
        If not, then we send native plugin message if
        library exists (using property detection - dataLayer).
        */
        const library = lodash_1.get(window, 'dataLayer', []);
        if (isClientMessage && this.clientAdapter) {
            this.sendMessage(message, true, targetOrigin);
        }
        else if (lodash_1.isArray(library)) {
            library.push(message);
        }
    }
    sendGoogleAnalyticsMessage(message, isClientMessage, targetOrigin = '*', trackerName) {
        /*
        If we have client adapter then we will send
        Google Analytics message to parent for handing.
        If not, then we send native plugin message if
        library exists (using property detection - dataLayer).
        */
        const library = lodash_1.get(window, 'ga', []);
        if (isClientMessage && this.clientAdapter) {
            this.sendMessage(message, true, targetOrigin);
        }
        else if (lodash_1.isFunction(library)) {
            const method = trackerName ? `${trackerName}.send` : 'send';
            library(method, message);
        }
    }
    start() {
        this.adapters.forEach((adapter) => {
            adapter.connect();
        });
    }
}
exports.BusService = BusService;
//# sourceMappingURL=BusService.js.map